/**
 * What a scrape upload contains — the `documentType` values of POST /api/scraper/upload
 * (api-scraper.yml). A quarterly report imports funds, reports and assets on approve; a capital
 * account statement instead stages capital-account blocks for the review queue; financial statements
 * and cashflow notices are extracted for review only, and approving either is refused until the
 * mapping lands.
 *
 * Capital account statements, financial statements and cashflow notices are each gated by an
 * organisation setting and rejected by the server while switched off.
 *
 * This map is the only type safety on the upload path: the generated client types `documentType` as a
 * bare `string`, so a value missing here reaches the server and is rejected there rather than failing
 * to compile. Keep it in step with both copies of api-scraper.yml.
 */
export const ScraperDocumentType = {
    QUARTERLY_REPORT: "qr",
    CAPITAL_ACCOUNT_STATEMENT: "cas",
    FINANCIAL_STATEMENTS: "fs",
    CASHFLOW_NOTICE: "cn"
} as const;

export type ScraperDocumentType = typeof ScraperDocumentType[keyof typeof ScraperDocumentType];
